// extracted by mini-css-extract-plugin
module.exports = {"resetZebra":"Zebra_resetZebra__3O_8_"};